import { useState, useRef } from 'react';
import { useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import PopperMenu from '../PopperMenu';

import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined';
import Button from '@mui/material/Button';

const SortButton = (props) => {
  const { typography, palette } = useTheme();
  const anchorRef = useRef(null);
  const [sortMenuOpen, setSortMenuOpen] = useState(false);
  const styles = {
    sortTemplateButton: {
      ...typography.body14bold,
      width: '112px',
      height: '44px',
      marginLeft: 'auto',
      backgroundColor: 'white',
      color: 'primary.main',
      border: '1px solid ' + palette.primary.main,
    },
  };

  return (
    <>
      <Button variant="outlined"
        sx={styles.sortTemplateButton}
        startIcon={<FilterListOutlinedIcon />}
        ref={anchorRef}
        onClick={() => {
          setSortMenuOpen(!sortMenuOpen);
        }}
      >
        並べ替え
      </Button>
      <PopperMenu
        anchorRef={anchorRef}
        open={sortMenuOpen}
        setOpen={setSortMenuOpen}
        items={props.items}
        initialItem={props.initialItem}
        tableData={props.tableData}
        setTableData={props.setTableData}
      />
    </>
  );
};

export default SortButton;

SortButton.propTypes = {
  items: PropTypes.array,
  initialItem: PropTypes.string,
  tableData: PropTypes.array,
  setTableData: PropTypes.func,
};
